const TRC_CONTENT = Object.freeze({
	TRC: 'trc',
	VIDEO: 'video'
});
export default TRC_CONTENT;
